import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from "@progress/kendo-react-buttons";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import { LoadingPanel } from "../../LoadingPanel";
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";

export const AdministratorMatchVenueEvent = (props) => {
    const dispatch = useDispatch();

    const [events, setEvents] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    
    const findEvents = () => {
        setIsLoading(true);

        const dataItem = {
            venueEventKey: props.venueEventKey,
        };
    
        fetch(`/api/administrator/pos/events`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setEvents(result);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const savePOSEventId = (posEventId) => {
        const dataItem = {
            posEventId: posEventId,
            venueEventKey: props.venueEventKey,
        };

        fetch("/api/administrator/pos/event",
            {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Saved POS Event Id successfully");  
                
                props.closeDialog();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    };

    const SelectCell = (cellProps) => {  
        const eventId = cellProps.dataItem.id;
        
        return (
            <td>
                <Button type={"button"} onClick={() => savePOSEventId(eventId)}>Select</Button>
            </td>
        );
    };

    useEffect(() => {
        findEvents();
    }, []);

    return (
        <div>
            <Grid
                data={events}
                resizable={false}
                scrollable="none"
                >
                <Column field="name" title={"Name"} />
                <Column field="eventDate" title={"Date"} />
                <Column cell={SelectCell} />
            </Grid>

            {isLoading ? <LoadingPanel /> : <></>}
        </div>
    );
}